import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles'

const muiTheme = createMuiTheme()
const responsiveTheme = responsiveFontSizes(muiTheme)

export default responsiveTheme